import { ConversationMessage } from 'features/chatbot/contexts/ChatbotDataLayer'
import { useMemo } from 'react'

interface ConversationThought {
  text: React.ReactNode
}

export type GroupedConversationItem =
  | { type: 'message'; data: ConversationMessage; index: number }
  | { type: 'thoughtGroup'; data: ConversationThought[]; index: number }

type ActiveThoughts = {
  thoughts: ConversationThought[]
  startIndex: number
}

type GroupedConversationResult = {
  conversationWithGroupedThoughts: GroupedConversationItem[]
  activeThoughts: ActiveThoughts | null
}

function groupConversationMessages(
  conversation: ConversationMessage[]
): GroupedConversationResult {
  const result: GroupedConversationItem[] = []
  let currentThoughtGroup: ConversationThought[] = []
  let thoughtGroupStartIndex = -1

  conversation.forEach((message, index) => {
    if (message.type === 'thought') {
      if (currentThoughtGroup.length === 0) {
        thoughtGroupStartIndex = index
      }
      currentThoughtGroup.push({ text: message.text })
    } else {
      if (currentThoughtGroup.length > 0) {
        result.push({
          type: 'thoughtGroup',
          data: currentThoughtGroup,
          index: thoughtGroupStartIndex,
        })
        currentThoughtGroup = []
      }
      result.push({
        type: 'message',
        data: message,
        index,
      })
    }
  })

  const activeThoughts =
    currentThoughtGroup.length > 0
      ? { thoughts: currentThoughtGroup, startIndex: thoughtGroupStartIndex }
      : null

  return { conversationWithGroupedThoughts: result, activeThoughts }
}

export function useGroupedConversation(
  conversation: ConversationMessage[]
): GroupedConversationResult {
  return useMemo(() => groupConversationMessages(conversation), [conversation])
}
